/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface ViewEnumerationActionSet
 */

/**
 * Check if a given object implements the ViewEnumerationActionSet interface.
 */
export function instanceOfViewEnumerationActionSet(value) {
  return true;
}
export function ViewEnumerationActionSetFromJSON(json) {
  return ViewEnumerationActionSetFromJSONTyped(json, false);
}
export function ViewEnumerationActionSetFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
export function ViewEnumerationActionSetToJSON(value) {
  return value;
}